import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getConnected } from '../../../ducks/sockets'
import BodyClass from '../../Shared/BodyClass'

import './OfflineBanner.css'

class OfflineBanner extends Component {
  render() {
    const { connected } = this.props

    return (
      <>
        {connected ? null : <BodyClass className="offline-banner-visible" />}
        <div className="offline-banner">
          You’re Offline! Your apps will not save until you reconnect.
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  connected: getConnected(state),
})

export default connect(mapStateToProps)(OfflineBanner)
